import { ViewController } from 'ionic-angular';
import { Component } from '@angular/core'

@Component({
  templateUrl: 'build/pages/more/more.html'
})
export class MoreModal {
  constructor(private controller: ViewController) {}
  
  dismiss() {
    this.controller.dismiss()
  }
}
